import { styled } from '@linaria/react';

const Button = styled.button`
  border-width: var(--bb-button-border-width);
  border-style: var(--bb-button-border-style);
  border-color: var(--bb-button-border-color);
  border-radius: var(--bb-button-border-radius);
  background-color: var(--bb-button-background);
  padding-top: var(--bb-button-padding-top);
  padding-right: var(--bb-button-padding-right);
  padding-bottom: var(--bb-button-padding-bottom);
  padding-left: var(--bb-button-padding-left);
  box-shadow: var(--bb-button-shadow);
  color: var(--bb-button-color);
  font-family: inherit;
  font-size: var(--bb-button-font-size);
  font-weight: var(--bb-button-font-weight);
  line-height: var(--bb-button-line-height);
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);

  &:hover {
    cursor: pointer;
    background-color: var(--bb-button-background--hover);
    border-color: var(--bb-button-border-color--hover);
    box-shadow: var(--bb-button-shadow--hover);
    color: var(--bb-button-color--hover);
  }

  &:active,
  &:focus {
    color: var(--bb-button-color--focus);
    box-shadow: var(--bb-button-shadow--focus);
    border-color: var(--bb-button-border-color--focus);
    background-color: var(--bb-button-background--focus);
  }

  &:disabled {
    color: var(--bb-button-color--disabled);
    background-color: var(--bb-button-background--disabled);
    border-color: var(--bb-button-border-color--disabled);
    box-shadow: var(--bb-button-shadow--disabled);
    cursor: default;
  }
`;

export default Button;
